/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FolderShared32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#2687FC"
                d="M6 6h6c2 0 1.5 2 4 2h10a3 3 0 013 3v13a3 3 0 01-3 3H6a3 3 0 01-3-3V9a3 3 0 013-3z"
            />
            <path
                fill={vars.bdlLightBlue50}
                d="M26 11a3 3 0 013 3v10a3 3 0 01-3 3H6a3 3 0 01-3-3V14a3 3 0 013-3h20zm-6.999 8c-1.117 0-1.933.543-2.439 1.401a6.024 6.024 0 01.414 1.45c.066.42.003.809-.165 1.138a1.7 1.7 0 00.193.011h4.002l.14-.006c.63-.054.924-.476.844-.988a5.028 5.028 0 00-.258-.997c-.453-1.2-1.367-2.009-2.73-2.009zM13 19c-1.364 0-2.278.81-2.731 2.01a4.774 4.774 0 00-.185.62c-.028.123-.053.25-.073.378-.084.54.258.992.992.992h4.002l.14-.006c.63-.054.924-.476.843-.988a5.028 5.028 0 00-.257-.997C15.277 19.81 14.363 19 13 19zm0-4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.001 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
            />
        </g>
    </AccessibleSVG>
);

export default FolderShared32;
